const { makeStyles } = require('@material-ui/core')
const { GRAY_COLORS } = require('asterX-UIkit')

export const useModuleStyles = makeStyles(theme => ({
  root: {
    marginTop: '20px',
    flexGrow: 1
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: '16px',
    cursor: 'pointer'
  },
  content: {
    flex: '1 0 auto'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 0,
    marginTop: 'auto'
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '56px',
    height: '56px',
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: '50%',
    backgroundColor: `${GRAY_COLORS[100]}`
  },
  title: {
    marginTop: '16px',
    fontSize: '16px'
  }
}))
